import React, {Component} from "react";
import ReactToPrint, { PrintContextConsumer }  from "react-to-print";
import { Link as RouterLink, useParams } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { Container, Button, Stack } from '@mui/material';
import { LayoutImpressao } from "./LayoutImpressao";
import './style.css';
import Theme from '../../components/Button';
import Iconify from '../../components/Iconify';

export class ImprimirEtiqueta extends Component {

  setComponentRef = (ref) => {
    this.componentRef = ref;
  };

  render () { 
    
    return (
      <>
          <LayoutImpressao ref={this.setComponentRef} />

          <ReactToPrint content={() => this.componentRef}>
            <PrintContextConsumer>
              {({ handlePrint }) => (
                <Container>
                  <div align="center" className="printer-ticket" >
                      <Stack display="block" direction="row" alignItems="center" spacing={5} >
                        <ThemeProvider theme={Theme}>
                          <Button color="neutral" variant="contained" onClick={handlePrint} startIcon={<Iconify icon="material-symbols:print" />}>
                            Imprimir
                          </Button>
                          <Button variant="contained" color="neutral" component={RouterLink} to={localStorage.getItem(['mesa']) ? `/venda_comercio/consultar/${localStorage.getItem(['mesa'])}` : '/venda_avulsa/consultar'} startIcon={<Iconify icon="eva:arrow-back-fill"/>}>
                            Voltar
                          </Button>
                        </ThemeProvider>
                      </Stack>
                  </div>
                </Container>
              )}
            </PrintContextConsumer>
          </ReactToPrint>
      </>
    )
  }
}
               